import React, { useRef } from 'react'
import { FleetGrid, useGridList } from '../../../../shared/sso-workspace/fleet-grid'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnFormat, ColumnText } from '../../../../shared/table-builder/table-columns'
import { IconList } from '../../../../shared/icon/icon'
import { formatMs, msClass } from './format'
import { formatCount } from '../../../../shared/sso-workspace/format'

// The slowest routes in the page's time range, slowest p95 first:
// route, service, count, p50 / p95 / p99 and errors. Picking a route filters
// the requests below to it.
//
// rows: undefined while loading, null when the load failed, else the routes.
export const SlowRoutes = ({ rows, onPick }) => {
  const tableRef = useRef()
  const apiList = useGridList(rows)

  const routeCell = row =>
    row.data
      ? <button type="button" className="btn btn-link p-0 sw-mono text-start text-decoration-none" aria-label={`Show ${row.data.method} ${row.data.route}`} onClick={() => onPick(row.data)}>
          <span className="rl-method">{row.data.method}</span> {row.data.route}
        </button>
      : ''

  return (
    <FleetGrid title="slowest routes" subtitle="By 95th percentile; pick one to see its requests" tableRef={tableRef} exportName="request-log-slow-routes" compact phoneTall>
      <TableAgClient
        pinFirstColumn
        ref={tableRef}
        queryKey="routes"
        sortCol="p95"
        sortDesc
        apiList={apiList}
        emptyState={{ Icon: IconList, title: 'No routes', message: 'No requests were recorded in this time range.' }}>
        <ColumnFormat field="route" header="Route" render={routeCell} sortable={false} minWidth={300} flex={4} />
        <ColumnText field="service" header="Service" />
        <ColumnFormat field="count" header="Requests" render={countCell} exportValue={r => r.count} />
        <ColumnFormat field="p50" header="p50" render={msCell} />
        <ColumnFormat field="p95" header="p95" render={msCell} />
        <ColumnFormat field="p99" header="p99" render={msCell} />
        <ColumnFormat field="serverErrors" header="5xx / 4xx" render={errorsCell} />
      </TableAgClient>
    </FleetGrid>
  )
}

export const msCell = row => (row.data && row.value !== null && row.value !== undefined ? <span className={msClass(row.value)}>{formatMs(row.value)}</span> : '')

// A route's request count; the cell value stays the number, so it sorts.
const countCell = row => (row.data ? formatCount(row.value) : '')

// Server errors (5xx) in red; client errors (4xx) beside them.
const errorsCell = row => {
  if (!row.data) return ''
  const { serverErrors = 0, clientErrors = 0 } = row.data
  return (
    <span title={`${formatCount(serverErrors)} server errors (5xx), ${formatCount(clientErrors)} client errors (4xx)`}>
      <span className={serverErrors ? 'sw-tone-bad fw-semibold' : ''}>{formatCount(serverErrors)}</span>
      <span className="sw-hint">{` / ${formatCount(clientErrors)}`}</span>
    </span>
  )
}
